import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

import { round } from '@core/common';

@Pipe({ name: 'laMetricValue' })
export class MetricValuePipe implements PipeTransform {
  locale = inject(LOCALE_ID);

  transform(value: number | string, decimalPlaces = 2, multiplier = 1): string | number {
    const parsedInput = this.parseInput(value, multiplier);
    if (parsedInput === null) {
      return '';
    }

    const parsedbsInput = Math.abs(parsedInput);
    const lt = parsedbsInput !== 0 && round(parsedbsInput, decimalPlaces) === 0;
    const minValue = 1 / Math.pow(10, decimalPlaces);

    return typeof parsedbsInput === 'number'
      ? lt
        ? `<${minValue.toLocaleString(this.locale, { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces })}`
        : `${parsedbsInput.toLocaleString(this.locale, { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces })}`
      : '';
  }

  private parseInput(value: string | number, multiplier: number): number | null {
    if (typeof value === 'number') {
      return value * multiplier;
    }

    const parsedFloat = parseFloat(value);
    if (!isNaN(parsedFloat)) {
      return parsedFloat * multiplier;
    }

    return null;
  }
}
